
//Lazada
import {
  Dashboard as LazadaDashboard,
  BookingFiles as LazadaBookingFiles,
  Shipments as LazadaShipments,
  ShipmentList as LazadaShipmentList,
  ShipmentDetail as LazadaShipmentDetail,
  AddDriver as LazadaAddDriver,
  MasterData3PL as LazadaMasterData3PL,
  ShipmentAgent as LazadaShipmentAgent,
  ThirdpartyDetail as Lazada3PLDetail,
  CashOnDelivery as LazadaCODDetail,
  ShipmentSubAgent as LazadaShipmentSubAgent,
  LazadaQueue,
} from 'views/Lazada/screens';

import DownloadReport from 'views/Report/DownloadReportList'
import Report from 'views/Report/Report';

const giztixMenu = () => {
  return !localStorage.getItem('giztixmenu');
};
const lazadaMenu = () => {
  return !localStorage.getItem('lazadamenu');
};
const jdMenu = () => {
  return !localStorage.getItem('jdmenu');
};

/* Sidebar menu */
const dashboardRoutes = [
  {
    path: '#',
    name: 'PROJECT',
    enName: 'projectGroup',
    icon: 'far fa-chess-queen',
    subMenu: [
      {
        hide: lazadaMenu() && giztixMenu(),
        path: '/lazada',
        name: 'LAZADA',
        icon: 'fal fa-heart',
        component: LazadaShipmentList,
      }
    ],
  },
  // LAZADA
  {
    hide: true,
    path: '/shipment-list',
    name: 'Shipment List',
    icon: 'fal fa-heart',
    component: LazadaShipmentList,
  },
  {
    hide: true,
    path: '/shipment-detail',
    name: 'Shipment Detail',
    icon: 'fal fa-heart',
    component: LazadaShipmentDetail,
  },
  //R E P O R T
  {
    hide: true,
    path: '/report',
    name: 'Report',
    component: DownloadReport
  },
  {
    redirect: true,
    path: '/',
    to: '/shipment-list',
    name: 'Project',
  },
  
  // { redirect: true, path: "/",to: "/shopee" , name: "SHOPEE" },
];

export default dashboardRoutes;
